import { render, staticRenderFns } from "./List.vue?vue&type=template&id=29d54ff1&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=29d54ff1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d54ff1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29d54ff1')) {
      api.createRecord('29d54ff1', component.options)
    } else {
      api.reload('29d54ff1', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=29d54ff1&scoped=true&", function () {
      api.rerender('29d54ff1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Article/List.vue"
export default component.exports